import PropTypes from 'prop-types'
import React from 'react'
import CSSModules from 'react-css-modules'
import classNames from 'classnames'
import themeTypes from 'helpers/enums/themes/themeTypes'

import styles from './regular_tooltip.scss'

const arrowPosition = {
	'top-left': 'top-left',
	'top-center': 'top-center',
	'top-right': 'top-right',
	'right-top': 'right-top',
	'right-center': 'right-center',
	'right-bottom': 'right-bottom',
	'bottom-right': 'bottom-right',
	'bottom-center': 'bottom-center',
	'bottom-left': 'bottom-left',
	'left-bottom': 'left-bottom',
	'left-center': 'left-center',
	'left-top': 'left-top',
}

const Tooltip = props => (
	<div styleName={classNames({
		container: true,
		[`container--${props.theme}`]: true,
		[`arrow--${arrowPosition[props.arrow]}`]: true,
	})}>
		{props.children}
	</div>
)

Tooltip.propTypes = {
	arrow: PropTypes.string,
	theme: PropTypes.oneOf([themeTypes.DARK, themeTypes.BLUE]),
	children: PropTypes.node,
}

Tooltip.defaultProps = {
	arrow: 'bottom-center',
	theme: themeTypes.DARK,
	children: null,
}

export default CSSModules(Tooltip, styles, {allowMultiple: true})
